export interface MarginNotesSlice {
    marginNotes: string | undefined;
}

export const initialMarginNotesSlice: MarginNotesSlice = {
    marginNotes: undefined
};
